import EditPostForm from "../../features/EditPostForm/EditPostForm";
const EditPost = () => {
  return (
    <>
      <h2>Edit Post</h2>
      <EditPostForm />
    </>
  );
};

export default EditPost;
